export const LEFT_MENU_TOGGLE = "LEFT_MENU_TOGGLE"
